module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"next":"Далее","fillCompanyInfo":"Прежде чем разместить вакансию, необходимо заполнить информацию о компании","vacancyInformation":"Информация о вакансии"}}')
  delete Component.options._Ctor
}
